
import { instance } from './_config.js'



const getDocuments = async (obj) => {
    try {
        const rs = await instance.post(`/documents/search`, obj)
        if (rs.data?.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}


const updateDocument = async (obj) => {
    try {
        //  if ((obj.documentType === 'invoice' && obj.documentStatus !== 'draft') || (obj.documentType === 'creditNote' && obj.documentStatus !== 'draft')) {
        //     return {
        //         error: true,
        //         message: obj.documentType === 'invoice' ? 'Invoices must be in draft status before being created or updated.' : 'Credit notes must be in draft status before being created or updated.',
        //     }
        // }
        const rs = await instance.post(`documents`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


const deleteDocument = async (obj) => {
    try {
        //  if ((obj.documentType === 'invoice' && obj.documentStatus !== 'draft') || (obj.documentType === 'creditNote' && obj.documentStatus !== 'draft')) {
        //     return {
        //         error: true,
        //         message: obj.documentType === 'invoice' ? 'Invoices must be in draft status before being created or updated.' : 'Credit notes must be in draft status before being created or updated.',
        //     }
        // }
        const rs = await instance.delete(`documents`, { data: { '_id': obj.id } })
        if (rs.data) {
            return rs.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


export { getDocuments, updateDocument, deleteDocument }